<mat-form-field class="w-100 control-helper_inline" [hideRequiredMarker]="!attributeDefinition.isRequired" (click)="datePicker.open()">
  <mat-label>{{ label }}</mat-label>

  <input matInput [ngxMatDatetimePicker]="datePicker" [formControl]="control" hidden>

  <div class="date-value">
    {{ control.value ? _datePickerUtilService.getDateString(control.value, false) : '\u00A0' }}
  </div>

  <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
  <button mat-icon-button matSuffix type="button" aria-label="Clear date" (click)="clear($event)"
    [disabled]="control?.disabled || control?.value == null">
    <mat-icon>close</mat-icon>
  </button>

  <ngx-mat-datetime-picker #datePicker [hideTime]="true" [touchUi]="true" (opened)="onOpen()" [startAt]="openAt">
  </ngx-mat-datetime-picker>
  <mat-error *ngIf="control?.invalid && (control?.dirty || control?.touched)">
    {{ getErrorMessage() }}
  </mat-error>
</mat-form-field>